import { render } from "./DraggableTable.vue?vue&type=template&id=59628fd7&scoped=true"
import script from "./DraggableTable.vue?vue&type=script&lang=ts"
export * from "./DraggableTable.vue?vue&type=script&lang=ts"

import "./DraggableTable.vue?vue&type=style&index=0&id=59628fd7&lang=scss"
import "./DraggableTable.vue?vue&type=style&index=1&id=59628fd7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59628fd7"

export default script